<div class="wrapper wrapper-full-page">
  <div class="backImage" data-color="azure">
      <section>
          <div class="loginHeader">
          </div>
      </section>


      <div class="content">
          <div class="container">
              <div class="row">
                  <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                      <form (ngSubmit)="authenticateRater(loginForm)" #loginForm="ngForm" novalidate="">

                          <div class="card">
                              <div class="logo">
                                  <img src="/assets/img/logo_eli.png" />
                              </div>

                              <div class="content">
                                  <div class="form-group">
                                      <label>Username</label>
                                      <input id="email" (keypress)="preventSpace(email.value, $event)" 
                                             (keyup)="preventSpace(email.value, $event)" 
                                             class="form-control" placeholder="Enter email" 
                                             name="email" required="" [(ngModel)]="user.email" #email="ngModel">
                                  </div>
                                  <div class="form-group">
                                      <label>Code</label>
                                      <input passwordDirective id="pass"
                                              (keypress)="preventSpace(pass.value, $event)"
                                              (keyup)="preventSpace(pass.value, $event)"
                                              class="form-control" placeholder="Code"
                                              type="password" name="pass" required=""
                                              [(ngModel)]="user.pass" #pass="ngModel">
                                  </div>
                              </div>

                              <br />
                              <div class="footer text-center">
                                  <button class="btn btn-fill btn-info btn-wd" type="submit">
                                      Start
                                  </button>
                              </div>
                              <br />
                          </div>

                      </form>

                  </div>
              </div>
          </div>
      </div>

      <section>
          <div class="loginFooter">
              <div class="col-md-12 text-right">
                  <p>2007 - {{currentYear}} iPEC Coaching. All Rights Reserved.</p>
              </div>
          </div>
      </section>
  </div>
</div>
